import { createContentPropTypes } from '../../../helpers/content';

// TODO: copy text for IFT and CHAPS will have to be finalized by IGS-3317.
const domesticPayeeContent = {
	title: 'Scheduled payments may need updated',
	body: [
		"The changes you've made will only apply for future payments to this payee. If you're already paying them by Direct Debit or standing order, you'll need to update those details too.",
		"You can update your standing order online but if you want to change a Direct Debit, you'll have to contact the company you're paying to make the changes for you.",
	],
	dismissButtonLabel: 'Cancel',
	confirmButtonLabel: 'OK',
};
const iftPayeeContent = {
	title: 'Scheduled payments may need updated',
	body: [
		"The changes you've made will only apply for future payments to this payee. If you're already paying them by Direct Debit or standing order, you'll need to update those details too.",
		"You can update your standing order online but if you want to change a Direct Debit, you'll have to contact the company you're paying to make the changes for you.",
	],
	dismissButtonLabel: 'Cancel',
	confirmButtonLabel: 'OK',
};
const chapsPayeeContent = {
	title: 'Scheduled payments may need updated',
	body: [
		"The changes you've made will only apply for future payments to this payee. If you're already paying them by Direct Debit or standing order, you'll need to update those details too.",
		"You can update your standing order online but if you want to change a Direct Debit, you'll have to contact the company you're paying to make the changes for you.",
	],
	dismissButtonLabel: 'Cancel',
	confirmButtonLabel: 'OK',
};

export default { domesticPayeeContent, iftPayeeContent, chapsPayeeContent };
export const contentPropTypes = createContentPropTypes(domesticPayeeContent);
